import React from 'react';
// Components
import { translatePartOfStringWithLink } from '../../../lib/StringUtils/StringHTMLUtils';
import { Namespace } from '../../../translation/namespace';
import { PasswordResetForm } from './forms/PasswordResetForm';
import { StatusInfoError } from '../../../_lib/components/StatusInfo';
import { StatusInfoModifier } from '../../../_lib/components/StatusInfo/partials/StatusInfo';

type PasswordReset = {
  form: any;
  elementType: string;
  errorType?: string;
  forgotPasswordUrl?: string;
};
/**
 * Renders the form for forgot password
 */
export default function PasswordReset({ form, elementType, errorType, forgotPasswordUrl }: PasswordReset) {
  if (errorType) {
    return (
      <StatusInfoError
        message={translatePartOfStringWithLink(
          `${Namespace.PasswordReset}:errorType.jwtTokenInvalidOrExpired`,
          forgotPasswordUrl
        )}
        modifier={[StatusInfoModifier.RED, StatusInfoModifier.ALIGN_LEFT]}
      />
    );
  }

  return <PasswordResetForm model={form} elementType={elementType} />;
}
